import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.20048 1.35482C6.66896 1.80985 11.2462 6.61571 11.2462 6.61571C11.4972 6.86004 11.6228 7.18058 11.6228 7.49888C11.6228 7.81942 11.4972 8.13996 11.2462 8.38204C11.2462 8.38204 6.66896 13.1879 6.20048 13.6452C5.732 14.1024 4.88918 14.1338 4.38932 13.6452C3.88946 13.1588 3.85135 12.4773 4.38932 11.8788L8.58996 7.49888L4.38932 3.11891C3.85135 2.52042 3.88946 1.84123 4.38932 1.35482C4.88918 0.866162 5.732 0.897544 6.20048 1.35482Z",
		fill: "currentColor"
	})
});
export default SvgIconChevronRight;
